/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from "react";
import * as Constant from "../../global/const";
import { useDispatch } from "react-redux";
import { setCarritoPromos } from "../../Redux/actions/CarritoPromoAction";
import { setCarrito } from "../../Redux/actions/CarritoAction";
//axios
import axios from "axios";

//Acordio of table
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";

//print for pdf
import { useReactToPrint } from "react-to-print";
import Print from "../ThankYou/Print"; // Asegúrate que la ruta a Print sea correcta
//redux
import { useSelector } from "react-redux";
import auth from "../../Helpers/auth"; // Asegúrate que la ruta a auth sea correcta
import { formatMoneda, parseMonto } from "../../Helpers/formatMoneda";

//datapicker
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@material-ui/core";

//Icons
import InfoDuda from "../../assets/icons/InfoDuda.svg";
import arrowUp from "../../assets/icons/Up.svg";
import arrowDown from "../../assets/icons/down.svg";
import IconPdf from "../../assets/icons/IconPdf.svg";
import search from "../../assets/icons/search-solid.svg";
import alert from "../../assets/icons/alert.svg";
import Loader from "react-loader-spinner";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TransparentLoader } from "../Loader/transparentLoader.component"; // Asegúrate que la ruta sea correcta
import Paginator from "../Pagination/paginador"; // Importa el componente Paginator basado en Ant Design

const MisPedidos = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [notifications, setNotifications] = useState([]);
  const componentRef = useRef();
  const [showModal, setShowModal] = useState(
    location.state && location.state.ModalResumen
  );
  const [OpenModalAlerta, setOpenModalAlerta] = useState(false);
  const [modificar, setModificar] = useState(false);
  const [openModalAnteriores, setOpenModalAnteriores] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const myRef = useRef();
  const [pedido, setPedido] = useState([]);
  const [pedidoHistorial, setPedidoHistorial] = useState([]);
  const [idPedido, setIdPedido] = useState(
    location.state && location.state.pedido && location.state.pedido.id
  );
  const [cardPedido, setCardPedido] = useState(
    location.state && location.state.pedido
  );
  let user = JSON.parse(auth.getUsuario());
  const [nOrden, setNOrden] = useState(
    location.state && location.state.pedido && location.state.pedido.numeroDoc
  );
  const [modalCancelarPedido, setModalCancelarPedido] = useState(false);
  const [modalAlertaCancelado, setModalAlertaCancelado] = useState(false);
  const [novedad, setNovedad] = useState(
    location.state && location.state.novedad
  );
  const sucursal = useSelector((state) => state.page.sucursal);
  const [resumen, setResumen] = useState([]);
  const [obsequios, setObsequios] = useState([]);
  const [elementos, setElementos] = useState([]);
  const [fi, setFi] = useState("");
  const [ff, setFf] = useState("");
  const [loader, setLoader] = useState(false);
  const [loaderPedidosCurso, setLoaderPedidosCurso] = useState(false);
  const [loaderPedidosAnteriores, setLoaderPedidosAnteriores] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [messageError, setMessageError] = useState("");
  
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 5; // Paginación de 5 para Pedidos Anteriores
  
  useEffect(() => {
    setCurrentPage(1);
  }, [openModalAnteriores, fi, ff]);

  // ***** LÓGICA DE DATOS CORREGIDA *****
  // Ahora la paginación SÍ se aplica a "Pedidos Anteriores"
  const itemsParaMostrar = openModalAnteriores
    ? resumen.slice( // Cortar la lista si es "Pedidos Anteriores"
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
      )
    : resumen; // Mostrar la lista completa si es "Pedidos en Curso"
  
  const setOpenModalError = (message) => {
    setOpenError(true);
    setMessageError(message);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getNovedadPedidos = async () => {
    await axios
      .get(
        Constant.NOVEDADPEDIDO +
          `?clienteUsuarioId=${user.id}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&nit=${sucursal.nit}&correo=${user.email}`
      )
      .then((response) => {
        setNotifications(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getModificarPedidos = async (nOrden) => {
    let aux = [];
    await axios
      .get(Constant.PEDIRDENUEVO + `?numeroDoc=${nOrden}`)
      .then((response) => {
        aux = response.data;
      })
      .catch((err) => {
        console.log("Error en getModificarPedidos:", err);
        aux = [];
      });
    return aux;
  };

  const handleChange = (panel) => {
    setExpanded(panel === expanded ? false : panel);
  };

  const cancelarPedido = () => {
    setLoader(true);
    let pedido = cardPedido;
    let numeroDoc = pedido.numeroDoc;
    let estado = pedido.esEditable ? 1 : 0;
    let detalleElementos = pedido.elementos;
    let url = Constant.CANCELARPEDIDO;
    let request = {
      id: idPedido,
      nit: sucursal.nit,
      correo: user.email,
      codigoCliente: sucursal.codigo,
      planta: sucursal.agencia,
      numeroDoc: numeroDoc,
      estado: estado,
      agenteId: user.id,
      detalleElementoCancelacion: detalleElementos || [],
    };
    axios
      .post(url, request)
      .then((response) => {
        setModalCancelarPedido(false);
        setModalAlertaCancelado(true);
        setLoader(false);
      })
      .catch((err) => {
        let message = err.response ? err.response.data.errr : err.message;
        setOpenModalError(message);
      })
      .finally(() => {
        setLoader(false);
        getHistorialCliente(1);
      });
  };

  const handleClickOutside = (event) => {
    if (
      myRef.current &&
      !myRef.current.contains(event.target) &&
      event.target.className.indexOf
    ) {
      if (event.target.className.indexOf("modal1") >= 0) {
      } else {
        setShowModal(false);
      }
    }
  };

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    var numeroDoc = params.get("numeroDoc");

    if (numeroDoc) {
      axios
        .get(Constant.GETRECIBO + "?numDoc=" + numeroDoc)
        .then((res) => {
          setPedido(res.data.pedido);
          setIdPedido(res.data.pedido.id);
          setNOrden(numeroDoc);
          setCardPedido(res.data.pedido);
          setShowModal(true);
        })
        .catch((err) => {
          console.log("error ", err);
        });
    }
  }, [location.search]);

  React.useEffect(() => {
    if (idPedido)
      axios
        .get(Constant.HISTORIALPEDIDODETALLE + `/${idPedido}`)
        .then((response) => {
          setPedidoHistorial(response.data);
        })
        .catch((err) => {
          console.log("error ", err);
        });
  }, [idPedido]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  React.useEffect(() => {
    if (sucursal) {
      getNovedadPedidos();
    }
  }, [sucursal]);

  const getHistorialCliente = (lista) => {
    setLoaderPedidosAnteriores(true);
    setLoaderPedidosCurso(true);
    axios
      .post(
        Constant.HISTORIALPEDIDOS +
          `?clienteUsuarioId=${user.id}&nit=${user.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&fi=${fi}&ff=${ff}&lista=${lista}`
      )
      .then((response) => {
        // Filtrar pedidos en curso: mostrar los que tienen fecha de entrega desde hoy hacia adelante
        if (lista === 1) {
          const hoy = new Date();
          hoy.setHours(0, 0, 0, 0); // Establecer hora a medianoche para comparar solo fechas
          
          const pedidosFiltrados = response.data.filter((pedido) => {
            if (!pedido.fechaEntrega) return false;
            
            // Convertir fechaEntrega a Date para comparar
            const fechaEntrega = new Date(pedido.fechaEntrega);
            fechaEntrega.setHours(0, 0, 0, 0);
            
            // Incluir pedidos con fecha de entrega desde hoy (>=) hacia adelante
            return fechaEntrega >= hoy;
          });
          
          setResumen(pedidosFiltrados);
        } else {
          setResumen(response.data);
        }
      })
      .catch((err) => {
        setResumen([]);
        console.log("error ", err);
      })
      .finally(() => {
        setLoaderPedidosCurso(false);
        setLoaderPedidosAnteriores(false);
      });
  };
  const getHistorialAnteriorCliente = () => {
    setLoaderPedidosAnteriores(true);
    axios
      .post(Constant.HistorialPedidoAnterior, {
        clienteUsuarioId: user.id,
        nit: user.nit,
        codigo: sucursal.codigo,
        agencia: sucursal.agencia,
        fi: fi,
        ff: ff,
      })
      .then((response) => {
        // Filtrar pedidos anteriores: excluir los que tienen fecha de entrega desde hoy hacia adelante (pedidos activos)
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // Establecer hora a medianoche para comparar solo fechas
        
        // Convertir fecha inicial a Date para comparar (formato YYYY-MM-DD)
        let fechaInicial = null;
        if (fi) {
          fechaInicial = new Date(fi + 'T00:00:00');
          fechaInicial.setHours(0, 0, 0, 0);
        }
        
        const pedidosFiltrados = response.data.filter((pedido) => {
          // Filtrar por fecha de entrega: solo pedidos con fecha de entrega anterior a hoy
          if (pedido.fechaEntrega) {
            const fechaEntregaStr = pedido.fechaEntrega.split('T')[0]; // Obtener solo la fecha YYYY-MM-DD
            const fechaEntrega = new Date(fechaEntregaStr + 'T00:00:00');
            fechaEntrega.setHours(0, 0, 0, 0);
            
            // Excluir pedidos con fecha de entrega >= hoy (pedidos activos)
            if (fechaEntrega >= hoy) {
              return false;
            }
          }
          
          // Filtrar por fecha de pedido: solo mostrar pedidos desde la fecha inicial hacia adelante (hasta hoy)
          if (fechaInicial && pedido.fechaRegistro) {
            // Extraer solo la fecha sin la hora (formato puede ser "2025-12-23 09:22" o "2025-12-23T09:22:00")
            const fechaPedidoStr = pedido.fechaRegistro.split('T')[0].split(' ')[0]; // Obtener solo YYYY-MM-DD
            const fechaPedido = new Date(fechaPedidoStr + 'T00:00:00');
            fechaPedido.setHours(0, 0, 0, 0);
            
            // Solo incluir pedidos con fecha de pedido >= fecha inicial
            if (fechaPedido < fechaInicial) {
              return false;
            }
          }
          
          return true;
        });
        
        setResumen(pedidosFiltrados);
      })
      .catch((err) => {
        setResumen([]);
        console.log("error ", err);
      })
      .finally(() => {
        setLoaderPedidosAnteriores(false);
      });
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (sucursal) {
      if (openModalAnteriores) {
        getHistorialAnteriorCliente();
      } else {
        getHistorialCliente(1);
      }
    }
  }, [fi, ff, sucursal, openModalAnteriores, modalAlertaCancelado]);

  return (
    <div className="bodyMisPedidos">
      {showModal ? (
        <div className="modalContainer ">
          <ModalResumen
            novedad={novedad}
            notificaciones={notifications}
            setShowModal={setShowModal}
            componentRef={componentRef}
            handlePrint={handlePrint}
            handleChange={handleChange}
            expanded={expanded}
            myRef={myRef}
            pedido={pedidoHistorial}
            cardPedido={cardPedido}
            nOrden={nOrden}
            sucursal={sucursal}
            user={user}
          />
        </div>
      ) : null}

      {OpenModalAlerta ? (
        <div className="modalContainer ">
          <ModalAlertaModificar
            getModificarPedidos={getModificarPedidos}
            nOrden={nOrden}
            setOpenModalAlerta={setOpenModalAlerta}
          />
        </div>
      ) : null}

      {modalCancelarPedido ? (
        loader ? (
          <div
            className="modalContainer "
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader type="ThreeDots" color="#0075BB" height={100} width={100} />
          </div>
        ) : (
          <div className="modalContainer ">
            <ModalAlertaCancelarPedido
              setModalCancelarPedido={setModalCancelarPedido}
              cancelarPedido={cancelarPedido}
            />
          </div>
        )
      ) : null}

      {modalAlertaCancelado ? (
        <div className="modalContainer ">
          <ModalPedidoCancelado
            setModalAlertaCancelado={setModalAlertaCancelado}
          />
        </div>
      ) : null}

      {openError ? (
        <div className="modalContainer ">
          <ModalPedidoError setOpen={setOpenError} message={messageError} />
        </div>
      ) : null}

      <div className="botones">
        <button
          className={openModalAnteriores ? "btn-blanco" : "btn-blanco-selected"}
          onClick={() => setOpenModalAnteriores(false)}
        >
          Pedidos en curso
        </button>
        <button
          className={openModalAnteriores ? "btn-blanco-selected" : "btn-blanco"}
          onClick={() => {
            setOpenModalAnteriores(true);
          }}
        >
          Pedidos anteriores
        </button>
      </div>

      <div className="listaPedidos overflow-auto scrollSlider">
        {openModalAnteriores ? (
          <PedidosAnteriores
            resumen={itemsParaMostrar}
            setIdPedido={setIdPedido}
            setFi={setFi}
            setFf={setFf}
            setCardPedido={setCardPedido}
            setNOrden={setNOrden}
            modalAnterioresActivo={openModalAnteriores}
            loaderPedidosAnteriores={loaderPedidosAnteriores}
            setOpenModalAlerta={setOpenModalAlerta}
          />
        ) : (
          <>
            <h1 className="titulo-listaPedido">
              {resumen && resumen.length > 0
                ? `Tienes ${resumen.length} pedidos en curso`
                : "No tienes pedidos en curso"}
            </h1>
            {resumen && resumen.length > 0 && (
              <h5 className="h5Curso">
                Los siguientes pedidos están programados para entrega, aún estás
                a tiempo de modificar o cancelar.
              </h5>
            )}
            <hr className="btn-line" />
            <CardPedido
              notificaciones={notifications}
              setOpenModalAlerta={setOpenModalAlerta}
              setShowModal={setShowModal}
              resumen={itemsParaMostrar}
              modalAnterioresActivo={false}
              setIdPedido={setIdPedido}
              setCardPedido={setCardPedido}
              setNOrden={setNOrden}
              setModalCancelarPedido={setModalCancelarPedido}
              setNovedad={setNovedad}
              loaderPedidosCurso={loaderPedidosCurso}
            />
          </>
        )}
      </div>

      {/* ***** LÓGICA DE RENDERIZADO DEL PAGINADOR CORREGIDA ***** */}
      {openModalAnteriores && resumen.length > ITEMS_PER_PAGE && (
        <Paginator
          totalItems={resumen.length}
          itemsPerPage={ITEMS_PER_PAGE}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};


// ===================================================================================
// ========================== COMPONENTES INTERNOS Y MODALES =========================
// ===================================================================================
// (El código de los siguientes componentes no requiere cambios)

const CardPedido = ({
  notificaciones,
  setOpenModalAlerta,
  setShowModal,
  resumen,
  setIdPedido,
  setCardPedido,
  setNOrden,
  modalAnterioresActivo,
  setModalCancelarPedido,
  setNovedad,
  loaderPedidosCurso,
}) => {
  const componentRef2 = useRef();
  const [orden, setorden] = useState([]);
  const [obsequios, setObsequios] = useState([]);
  const [posImpresion, setPosImpresion] = useState(-1);

  const handlePrint2 = useReactToPrint({
    content: () => componentRef2.current,
  });

  const getObsequios = async (pedido) => {
    let auxObsequios = [];
    if (pedido && pedido.promociones) {
      pedido.promociones.forEach((producto) => {
        if (producto.detallePromocion) {
          producto.detallePromocion.forEach((promocion) => {
            auxObsequios.push(promocion);
          });
        }
      });
    }
    setObsequios(auxObsequios);
  };

  const getRecibo = async (numOrdenCompra, numeroDocumento) => {
    await axios
      .get(Constant.GETRECIBOPEDIDOS + "?numPadre=" + numOrdenCompra)
      .then((response) => {
        setorden(response.data);
        if (response.data && response.data.pedido) {
          getObsequios(response.data.pedido);
        }
      })
      .catch((err) => {
        console.log("error en getRecibo de CardPedido: ", err);
      });
  };

  const searchDoc = (numeroDoc) => {
    if (!notificaciones || notificaciones.length === 0) return false;
    const aux = notificaciones.find((n) => n.orden === numeroDoc);
    return !!aux;
  };

  const getEstadoPedido = (pedido) => {
    // Mapeo de estadoId a descripción de estado
    const estadosMap = {
      '1': 'Pendiente',
      '2': 'En preparación',
      '3': 'En camino',
      '4': 'Cancelado por el cliente',
      '5': 'Cancelado',
      '6': 'Entregado',
      '7': 'Rechazado',
    };

    // Primero verificar si existe estado Descripcion (campo más confiable del backend)
    if (pedido.estadoDescripcion && typeof pedido.estadoDescripcion === 'string' && pedido.estadoDescripcion.trim() !== '') {
      return pedido.estadoDescripcion;
    }

    // Si estado es string y no está vacío, usarlo
    if (pedido.estado && typeof pedido.estado === 'string' && pedido.estado.trim() !== '') {
      return pedido.estado;
    }

    // Si estado es número, usar el mapeo
    if (pedido.estado && typeof pedido.estado === 'number') {
      const estadoIdStr = String(pedido.estado);
      return estadosMap[estadoIdStr] || `Estado ${pedido.estado}`;
    }

    // Si existe estadoId, usarlo para determinar el estado
    if (pedido.estadoId) {
      const estadoIdStr = String(pedido.estadoId);
      return estadosMap[estadoIdStr] || `Estado ${pedido.estadoId}`;
    }

    // Fallback: si no hay estado ni estadoId, mostrar información derivada
    if (pedido.esEditable) return "Activo";
    return "En proceso";
  };

  return (
    <div className="pedido">
      {loaderPedidosCurso && !modalAnterioresActivo ? (
        <div
          className="loader_centerPages"
          style={{ height: "auto", minHeight: "200px" }}
        >
          {" "}
          <Loader type="ThreeDots" color="#0075BB" height={100} width={100} />
        </div>
      ) : (
        resumen &&
        resumen.map((itemCardPedido, i) => (
          <div
            key={itemCardPedido.id || i + "cardPedido"}
            className={"pedido-item"}
          >
            {modalAnterioresActivo ? (
              <>
                <h5 className="pedido-title">
                  # Orden:
                  <h5 className="pedido-title-orden">
                    {itemCardPedido.ordenCompra}
                  </h5>
                </h5>
                <div role="button" className={"pedido-button"}>
                  <div
                    className="btn_pdf no-seleccionable"
                    onClick={async () => {
                      await getRecibo(
                        itemCardPedido.ordenCompra,
                        itemCardPedido.numeroDoc
                      );
                      setPosImpresion(i);
                      setTimeout(handlePrint2, 100);
                    }}
                  >
                    <img src={IconPdf} className="img_pdf" alt="Imprimir PDF" />{" "}
                    {itemCardPedido.ordenCompra &&
                    posImpresion === i &&
                    orden &&
                    orden.pedido ? (
                      <div style={{ display: "none" }}>
                        <Print
                          ref={componentRef2}
                          orden={orden}
                          obsequios={obsequios}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <h5 className="pedido-title">
                  Fecha de pedido:
                  <h5>
                    {itemCardPedido.fechaRegistro
                      ?.replace("T", " ")
                      .slice(0, 16)}{" "}
                  </h5>
                </h5>
                <h5 className="pedido-title">
                  Fecha de entrega:
                  <h5>
                    {itemCardPedido.fechaEntrega
                      ?.replace("T", " ")
                      .slice(0, 16)}{" "}
                  </h5>
                </h5>
                <h5 className="pedido-title">
                  Sucursal:<h5>{itemCardPedido.razonSocial}</h5>
                </h5>
                <h5 className="pedido-title">
                  Estado:<h5>{getEstadoPedido(itemCardPedido)}</h5>
                </h5>
                <h5 className="pedido-title">
                  Tipo de pago:<h5>{itemCardPedido.tipoPago}</h5>
                </h5>
              </>
            ) : (
              <>
                <h5 className="pedido-title">
                  # Orden:
                  <h5 className="pedido-title-orden">
                    {itemCardPedido.numeroDoc}
                  </h5>
                </h5>
                <div
                  className={
                    "novedad " +
                    (searchDoc(itemCardPedido.numeroDoc) ? "" : "hide")
                  }
                  role="button"
                >
                  Pedido con novedad <img src={alert} alt="Alerta de novedad" />
                </div>
                <h5 className="pedido-title">
                  Fecha de pedido:
                  <h5>
                    {itemCardPedido.fechaRegistro
                      ?.replace("T", " ")
                      .slice(0, 16)}
                  </h5>
                </h5>
                <h5 className="pedido-title">
                  Fecha de entrega:
                  <h5>
                    {itemCardPedido.fechaEntrega
                      ?.replace("T", " ")
                      .slice(0, 10)}
                  </h5>
                </h5>
                <h5 className="pedido-title">
                  Sucursal:<h5>{itemCardPedido.razonSocial}</h5>
                </h5>
                <h5 className="pedido-title">
                  Estado:<h5>{getEstadoPedido(itemCardPedido)}</h5>
                </h5>
                <h5 className="pedido-title">
                  Tipo de pago:<h5>{itemCardPedido.tipoPago}</h5>
                </h5>
              </>
            )}
            <h5 className="pedido-title">
              Dirección de entrega:<h5> {itemCardPedido.direccion} </h5>
            </h5>
            <h5 className="pedido-title">
              <h5>{itemCardPedido.ciudad}</h5>
            </h5>
            <hr className="btn-line-h5" align="left" />
            <div className="pedido-title-valorT">
              <div className="precioProducto">
                <h5>Valor total:</h5>
                <h4 className="ahora">{" $" + formatMoneda(itemCardPedido.valor)}</h4>
              </div>
              {!modalAnterioresActivo && (
                <div className="h5-botones">
                  <button
                    className="h5-btn-pedido"
                    onClick={() => {
                      setShowModal(true);
                      setIdPedido(itemCardPedido.id);
                      setCardPedido(itemCardPedido);
                      setNOrden(itemCardPedido.numeroDoc);
                      setNovedad(searchDoc(itemCardPedido.numeroDoc));
                    }}
                  >
                    Ver detalle
                  </button>
                  {itemCardPedido.esEditable && (
                    <div className="h5-cancelar">
                      <u
                        role="button"
                        onClick={() => {
                          setIdPedido(itemCardPedido.id);
                          setCardPedido(itemCardPedido);
                          setModalCancelarPedido(true);
                        }}
                      >
                        Cancelar pedido
                      </u>
                    </div>
                  )}
                </div>
              )}

              {modalAnterioresActivo && (
                <div className="h5-botones">
                  <button
                    className="h5-btn-pedido modificar"
                    onClick={() => {
                      setNOrden(itemCardPedido.numeroDoc);
                      setOpenModalAlerta(true);
                    }}
                  >
                    Pedir nuevamente
                  </button>
                </div>
              )}
            </div>
            <hr className="btn-line-h5" align="left" />
            <hr className="btn-line" />
          </div>
        ))
      )}
    </div>
  );
};

export const ModalResumen = ({
  novedad,
  handlePrint,
  componentRef,
  handleChange,
  expanded,
  myRef,
  pedido,
  cardPedido,
  nOrden,
  sucursal,
  user,
  setShowModal,
}) => {
  const [orden, setorden] = useState([]);
  const [obsequios, setObsequios] = useState([]);
  const [elementos, setElementos] = useState([]);
  const [mensajes, setMensajes] = useState([]);
  const [habilitarPdf, setHabilitarPdf] = useState(false);

  const getObsequiosModal = async (pedidoRecibo) => {
    let auxObsequios = [];
    if (pedidoRecibo && pedidoRecibo.promociones) {
      await Promise.all(
        pedidoRecibo.promociones.map((producto) => {
          if (producto.detallePromocion) {
            producto.detallePromocion.map((promocion) => {
              auxObsequios.push(promocion);
            });
          }
        })
      );
    }
    setObsequios(auxObsequios);
  };

  const getElementosModal = async () => {
    let auxElementos = [];
    if (pedido && pedido.detalleElementos) {
      pedido.detalleElementos.map((producto) => {
        auxElementos.push(producto);
      });
    }
    setElementos(auxElementos);
  };

  useEffect(() => {
    if (pedido && pedido.detalleElementos) {
      getElementosModal();
    }
  }, [pedido]);

  const llenarData = async (data) => {
    setorden(data);
    if (data && data.pedido) {
      await getObsequiosModal(data.pedido);
    }
    setHabilitarPdf(true);
  };

  const getReciboModal = (numeroDocPedido) => {
    if (numeroDocPedido && cardPedido && cardPedido.numeroDoc) {
      axios
        .get(
          Constant.GETRECIBOPEDIDOS +
            `?numPadre=${cardPedido.ordenCompra || numeroDocPedido}`
        )
        .then((response) => {
          llenarData(response.data);
        })
        .catch((err) => {
          console.log("error en getReciboModal: ", err);
          setHabilitarPdf(false);
        });
    } else {
      setHabilitarPdf(false);
    }
  };

  const getDetalleNovedadPedidos = async (numeroDocPedido) => {
    if (!numeroDocPedido || !sucursal || !user) return;
    await axios
      .get(
        Constant.NOVEDADPEDIDODETALLE +
          `?numeroDoc=${numeroDocPedido}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&nit=${sucursal.nit}&correo=${user.email}`
      )
      .then((response) => {
        if (
          response.data &&
          response.data.length > 0 &&
          response.data[0].novedades
        ) {
          setMensajes(response.data[0].novedades);
        } else {
          setMensajes([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setMensajes([]);
      });
  };

  useEffect(() => {
    if (nOrden && sucursal && user && cardPedido) {
      getReciboModal(nOrden);
      if (novedad) {
        getDetalleNovedadPedidos(nOrden);
      } else {
        setMensajes([]);
      }
    }
  }, [nOrden, sucursal, user, cardPedido, novedad]);

  useEffect(() => {
    const handleClickOutsideModal = (event) => {
      if (myRef.current && !myRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideModal);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideModal);
    };
  }, [myRef, setShowModal]);

  if (!cardPedido) return null;

  return (
    <div className="modalPrestamo modal1" ref={myRef}>
      <div className="BodyThank ">
        <div className="HeadResumen">
          <div className="HeadResumen-titulos">
            <h1>Resumen del pedido</h1>
            <img
              src={alert}
              alt="Alerta de novedad"
              className={novedad ? "" : "hide"}
            />
          </div>
          {habilitarPdf && orden && orden.pedido && (
            <div
              role="button"
              tabIndex={0}
              className="btn_pdf no-seleccionable"
              onClick={handlePrint}
              onKeyDown={(e) => e.key === "Enter" && handlePrint()}
            >
              {" "}
              <span>Descargar PDF</span>
              <img src={IconPdf} className="img_pdf" alt="Descargar PDF" />
            </div>
          )}
          {habilitarPdf && orden && orden.pedido ? (
            <div style={{ display: "none" }}>
              <Print ref={componentRef} orden={orden} obsequios={obsequios} />
            </div>
          ) : null}
        </div>

        <div className="BodyResumen scrollSlider">
          <div className="paddin scrollSlider">
            {novedad && mensajes && mensajes.length > 0 && (
              <div className={"panel"}>
                <div aria-controls="panel1bh-content" className="panelHeader">
                  <h1>Pedido novedad</h1>
                  {mensajes.map((msj, i) => (
                    <p key={msj.codigoSku || `msj-${i}`}> {msj.novedad} </p>
                  ))}
                </div>
              </div>
            )}
            <div className="panel">
              <div
                aria-controls="panel1bh-content"
                id="panel1bh-header-resumen"
                className="panelBody"
              >
                <img src={InfoDuda} alt="Información" />
                <h1 className="texto">
                  Tu número de orden es:
                  <span className="textoSpan">
                    {" "}
                    {cardPedido.ordenCompra || nOrden}{" "}
                  </span>
                </h1>
              </div>
            </div>
            {orden &&
              orden.pedido && (
                <Accordion expanded={expanded === "panel2"} className="panel">
                  <AccordionSummary
                    onClick={() => handleChange("panel2")}
                    aria-controls="panel2bh-content-resumen"
                    id="panel2bh-header-resumen"
                    className="panelBody"
                  >
                    <div className="panel_inside">
                      <div>
                        <img src={InfoDuda} alt="Información" />
                        <h1 className="texto">
                          Tu pedido tiene{" "}
                          <span className="textoSpan">
                            {(orden.pedido.productos
                              ? orden.pedido.productos.length
                              : 0) +
                              (obsequios ? obsequios.length : 0) +
                              (elementos ? elementos.length : 0)}{" "}
                          </span>{" "}
                          productos para un total de
                          <span className="textoSpan">
                            {" $" + formatMoneda(cardPedido.valor)}
                          </span>
                        </h1>
                      </div>
                      <div className="btn_Open">
                        <span>
                          <span>Ver</span> productos
                        </span>
                        <img
                          src={expanded === "panel2" ? arrowUp : arrowDown}
                          alt={
                            expanded === "panel2"
                              ? "Cerrar productos"
                              : "Ver productos"
                          }
                        />
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="list_products">
                      <div className="table_thankyou">
                        <span id="left_span_res_prod">Producto</span>{" "}
                        <span id="center_span_res_cajas">Cajas</span>
                        <span id="center_span_res_unid">Unidades</span>
                        <span id="center_span_res_total">Total</span>
                      </div>
                      {orden.pedido.productos &&
                        orden.pedido.productos.map((producto, i) => (
                          <div
                            className="product_row"
                            key={`prod-detalle-${producto.codigoSku || i}`}
                          >
                            <span id={`left_span_val_prod_${i}`}>
                              {producto.nombre
                                ? producto.nombre
                                : producto.producto}
                            </span>
                            <span id={`center_span_val_cajas_${i}`}>
                              {producto.cantidad}
                            </span>
                            <span id={`center_span_val_unid_${i}`}>
                              {producto.cantidadUnidadDigitada}
                            </span>
                            <span id={`center_span_val_total_${i}`}>
                              {" $" + formatMoneda(producto.total)}
                            </span>
                          </div>
                        ))}
                      {obsequios &&
                        obsequios.length > 0 &&
                        obsequios.map((obsequio, i) => (
                          <div
                            className="product_row"
                            key={`obs-detalle-${obsequio.codigoSku || i}`}
                          >
                            <span id={`left_span_val_obs_${i}`}>
                              {obsequio.producto}
                            </span>
                            <span id={`center_span_val_obs_cajas_${i}`}>
                              {obsequio.cantidad}
                            </span>
                            <span id={`center_span_val_obs_unid_${i}`}>
                              {obsequio.cantidadUnidadDigitada}
                            </span>
                            <span id={`center_span_val_obs_total_${i}`}>
                              {" $" + formatMoneda(obsequio.total)}
                            </span>
                          </div>
                        ))}
                      {elementos &&
                        elementos.length > 0 &&
                        elementos.map((elemento, i) => (
                          <div
                            className="product_row"
                            key={`elem-detalle-${elemento.codigoSku || i}`}
                          >
                            <span id={`left_span_val_elem_${i}`}>
                              {elemento.nombreElemento}
                            </span>
                            <span id={`center_span_val_elem_cajas_${i}`}>
                              {elemento.cantidadCajas}
                            </span>
                            <span id={`center_span_val_elem_unid_${i}`}>
                              {elemento.cantidadUnidad}
                            </span>
                            <span id={`center_span_val_elem_total_${i}`}>
                              {" $" + formatMoneda(elemento.total)}
                            </span>
                          </div>
                        ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              )}
            <div className="panel">
              <div
                aria-controls="panel3bh-content-resumen"
                id="panel3bh-header-resumen"
                className="panelBody"
              >
                <img src={InfoDuda} alt="Información" />
                <div className="panelBody-aux">
                  <h1 className="texto">
                    Fecha de orden:{" "}
                    <span className="textoSpan">
                      {cardPedido.fechaRegistro?.replace("T", " ").slice(0, 16)}
                    </span>
                  </h1>
                  <h1 className="texto">
                    Fecha de entrega:{" "}
                    <span className="textoSpan">
                      {cardPedido.fechaEntrega?.replace("T", " ").slice(0, 10)}
                    </span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="pieModal">
            <div>
              <h1 className="textoModal">
                Subtotal
                <span className="textoPie">
                  <div className="precioProducto">
                    <h4 className="ahora">
                      {" $" +
                        formatMoneda(
                          parseMonto(cardPedido.valor) -
                            parseMonto(cardPedido.totalImpuestos)
                        )}
                    </h4>
                  </div>
                </span>
              </h1>
              <h1 className="textoModal">
                Impuestos
                <span className="textoPie">
                  <div className="precioProducto">
                    <h4 className="ahora">
                      {" $" + formatMoneda(cardPedido.totalImpuestos)}
                    </h4>
                  </div>
                </span>
              </h1>
            </div>
            <div>
              <h1 className="textoModal ">
                Total
                <span className="textoPie">
                  <div className="precioProducto">
                    <h4 className="ahora">
                      {" $" + formatMoneda(cardPedido.valor)}
                    </h4>
                  </div>
                </span>
              </h1>

              <h1 className="textoModal">
                ENVIO
                <span className="textoPie"> GRATIS</span>
              </h1>
            </div>
            {orden && orden.pedido && (
              <div className="totalPie">
                <h1 className="textoModal">
                  Descuento otorgado
                  <span className="textoPie">
                    <div className="precioProducto">
                      <h4 className="ahora">
                        {" $" + formatMoneda(orden.pedido.valorDesc)}
                      </h4>
                    </div>
                  </span>
                </h1>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const ModalAlertaModificar = ({
  getModificarPedidos,
  nOrden,
  setOpenModalAlerta,
}) => {
  const dispatch = useDispatch();
  const myRefAlerta = useRef();
  const history = useHistory();
  const [block, setBlock] = useState(false);

  const AgregarCarritoLocal = (_carrito) => {
    dispatch(setCarrito(_carrito));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (myRefAlerta.current && !myRefAlerta.current.contains(event.target)) {
        if (!block) {
          setOpenModalAlerta(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [block, setOpenModalAlerta]);

  const cargar = (productosDelPedidoAnterior) => {
    if (!Array.isArray(productosDelPedidoAnterior)) {
      console.error(
        "Error en cargar: La entrada no es un array de productos.",
        productosDelPedidoAnterior
      );
      setBlock(false);
      return;
    }

    localStorage.removeItem(Constant.CARRITO);
    localStorage.removeItem(Constant.CARRITOPROMO);

    let _carrito = {};

    productosDelPedidoAnterior.forEach((productoApi) => {
      if (!productoApi || !productoApi.codigoSku) {
        console.warn(
          "Producto de API inválido o incompleto en la lista, omitiendo:",
          productoApi
        );
        return;
      }

      const promocionesDelProductoApi = productoApi.promocion || [];
      let precioFinal = parseFloat(productoApi.precio) || 0;
      let precioBaseFinal = parseFloat(productoApi.precioBase) || 0;

      if (
        promocionesDelProductoApi.length > 0 &&
        typeof promocionesDelProductoApi[0].precio === "number"
      ) {
        precioFinal = parseFloat(promocionesDelProductoApi[0].precio);
        precioBaseFinal = parseFloat(
          promocionesDelProductoApi[0].precioBase || productoApi.precioBase
        );
      }

      _carrito["-" + productoApi.codigoSku] = {
        codigoSku: productoApi.codigoSku,
        nombre: productoApi.nombre,
        precio: precioFinal,
        precioBase: precioBaseFinal,
        retornable: productoApi.retornable || "",
        oferta: productoApi.oferta || "",
        iva: parseFloat(productoApi.ivaPesos) || 0,
        ipo: parseFloat(productoApi.ipo) || 0,
        cantidad: parseInt(productoApi.cantidadPedirNuevamente, 10) || 1,
        categoria: productoApi.categoriaId,
        vinetas: productoApi.vinetas || [],
        promocion: promocionesDelProductoApi,
        promocionRedime: productoApi.promocionRedime || [],
        presentacionId: productoApi.presentacionId,
        permiteMedia: productoApi.permiteMedia,
        unidadesxCaja: productoApi.unidadesxCaja || 0,
        icui: 0,
        ibua: 0,
        icl: 0,
        adv: 0,
      };
    });

    AgregarCarritoLocal(_carrito);
    history.push({
      pathname: "/carrito",
    });
  };

  const handleAceptarPedirNuevamente = () => {
    setBlock(true);
    getModificarPedidos(nOrden)
      .then((respuestaApiProductos) => {
        cargar(respuestaApiProductos);
      })
      .catch((error) => {
        console.error(
          "Error al obtener el pedido para 'Pedir Nuevamente':",
          error
        );
        setBlock(false);
      });
  };

  return (
    <div className="modalAlerta" ref={myRefAlerta}>
      {" "}
      {block ? (
        <>
          <TransparentLoader />
          <div className="textosModalAlerta">
            <h5> Cargando tu pedido...</h5>
          </div>
        </>
      ) : (
        <>
          <div
            className="option-cerrar"
            onClick={() => {
              if (!block) setOpenModalAlerta(false);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) =>
              e.key === "Enter" && !block && setOpenModalAlerta(false)
            }
          >
            <h1>Cerrar</h1>
            <i className="fas fa-times"> </i>
          </div>
          <div className="textosModalAlerta">
            <h1>Los productos que has solicitado </h1>
            <h1>están sujetos a disponibilidad de inventario.</h1>
            <h5> Número orden: {nOrden}.</h5>
          </div>
          <div className="botones-alerta">
            <button
              className="btn-alerta1"
              onClick={handleAceptarPedirNuevamente}
              disabled={block}
            >
              Aceptar
            </button>
            <button
              className="btn-alerta2"
              onClick={() => {
                if (!block) setOpenModalAlerta(false);
              }}
              disabled={block}
            >
              Cancelar
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const ModalAlertaCancelarPedido = ({
  setModalCancelarPedido,
  cancelarPedido,
}) => {
  const myRefModal = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (myRefModal.current && !myRefModal.current.contains(event.target)) {
        setModalCancelarPedido(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [myRefModal, setModalCancelarPedido]);

  return (
    <div className="modalAlerta" ref={myRefModal}>
      <div
        className="option-cerrar"
        onClick={() => setModalCancelarPedido(false)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && setModalCancelarPedido(false)}
      >
        <h1>Cerrar</h1>
        <i className="fas fa-times"> </i>
      </div>
      <div className="textosModalAlerta">
        <h1>¿Estás seguro de que deseas cancelar</h1>
        <h1>tu pedido?</h1>
      </div>
      <div className="botones-alerta">
        <button className="btn-alerta1" onClick={cancelarPedido}>
          Si
        </button>
        <button
          className="btn-alerta2"
          onClick={() => setModalCancelarPedido(false)}
        >
          No
        </button>
      </div>
    </div>
  );
};

const ModalPedidoCancelado = ({ setModalAlertaCancelado }) => {
  const myRefModal = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (myRefModal.current && !myRefModal.current.contains(event.target)) {
        setModalAlertaCancelado(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [myRefModal, setModalAlertaCancelado]);

  return (
    <div className="modalAlerta" ref={myRefModal}>
      <div
        className="option-cerrar"
        onClick={() => setModalAlertaCancelado(false)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && setModalAlertaCancelado(false)}
      >
        <h1>Cerrar</h1>
        <i className="fas fa-times"> </i>
      </div>
      <div className="textosModalAlerta">
        <h1>Tu pedido </h1>
        <h5>ha sido cancelado con éxito.</h5>
        <i
          className="fas fa-check-circle"
          style={{
            display: "flex",
            fontSize: "5rem",
            justifyContent: "center",
            paddingTop: "1rem",
            color: "green",
          }}
        ></i>
      </div>
    </div>
  );
};

const ModalPedidoError = ({ setOpen, message }) => {
  const myRefModal = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (myRefModal.current && !myRefModal.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [myRefModal, setOpen]);

  return (
    <div className="modalAlerta" ref={myRefModal}>
      <div
        className="option-cerrar"
        onClick={() => setOpen(false)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && setOpen(false)}
      >
        <h1>Cerrar</h1>
        <i className="fas fa-times"> </i>
      </div>
      <div className="textosModalAlerta">
        <h1>Error</h1>
        <p style={{ marginTop: "1rem" }}>
          {message || "Ha ocurrido un error inesperado."}
        </p>{" "}
      </div>
      <div className="botones-alerta">
        {" "}
        <button className="btn-alerta2" onClick={() => setOpen(false)}>
          Aceptar
        </button>
      </div>
    </div>
  );
};

const PedidosAnteriores = ({
  resumen,
  setIdPedido,
  setFi,
  setFf,
  setCardPedido,
  setNOrden,
  modalAnterioresActivo,
  loaderPedidosAnteriores,
  setOpenModalAlerta,
}) => {
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, handleDateChange] = useState(today);

  useEffect(() => {
    setFi(selectedDate);
    setFf(""); // Fecha final vacía ya que no se usa
  }, [selectedDate, setFi, setFf]);

  const handleDateChangeWithValidation = (e) => {
    const selectedValue = e.target.value;
    // Validar que la fecha seleccionada no sea mayor que hoy
    if (selectedValue <= today) {
      handleDateChange(selectedValue);
    } else {
      // Si intenta seleccionar una fecha futura, mantener la fecha actual
      handleDateChange(today);
    }
  };

  return (
    <>
      <div className="bodyPedidosAnteriores">
        <h1>Este es tu historial de pedidos</h1>
        <h5>
          Encuentra aquí los pedidos que has realizado. Para encontrar lo que
          necesitas selecciona una fecha.
        </h5>
        <div>
          <div className="fechas">
            <p>Búsqueda por fecha</p>
            <TextField
              id="dateDesdeAnteriores"
              label="Fecha inicial"
              type="date"
              value={selectedDate}
              max={today}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                max: today,
              }}
              onChange={handleDateChangeWithValidation}
            />
            <img
              alt="Buscar pedidos por fecha"
              className={"fechas-img"}
              role="button"
              src={search}
              style={{ cursor: "pointer", marginLeft: "10px" }}
            />
          </div>
        </div>
        <hr className="btn-line" />
        {loaderPedidosAnteriores ? (
          <div
            className="loader_centerPages"
            style={{ height: "auto", minHeight: "200px" }}
          >
            <Loader type="ThreeDots" color="#0075BB" height={100} width={100} />
          </div>
        ) : (
          <div className="listaPedidos ">
            {resumen && resumen.length > 0 ? (
              <CardPedido
                resumen={resumen}
                setNOrden={setNOrden}
                modalAnterioresActivo={true}
                setOpenModalAlerta={setOpenModalAlerta}
              />
            ) : (
              <p>
                No se encontraron pedidos para la fecha seleccionada.
              </p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default MisPedidos;